import { supabase } from '../api/supabase'
import { diffRoleIds } from './companyRolesDiff'

// Saves a company's roles (customer_address_types) as a DIFF. Replaces the old "delete every role of the company, then insert the ticked ones":
// two separate requests, so a failed insert left the company with NO roles and no error (and a form opened before a bulk role change wiped it).
// Adds go first: if they fail nothing has been removed, and the error is thrown to the caller (never swallowed).
export async function saveCompanyRoles(customerId: string, original: ReadonlySet<string>, selected: ReadonlySet<string>): Promise<void> {
  const { toAdd, toRemove } = diffRoleIds(original, selected)
  if (toAdd.length > 0) {
    const { error } = await supabase.from('customer_address_types')
      .upsert(toAdd.map(tid => ({ customer_id: customerId, address_type_id: tid })), { onConflict: 'customer_id,address_type_id', ignoreDuplicates: true })
    if (error) throw new Error(error.message)
  }
  if (toRemove.length > 0) {
    const { error } = await supabase.from('customer_address_types').delete().eq('customer_id', customerId).in('address_type_id', toRemove)
    if (error) throw new Error(error.message)
  }
}
